import { ChevronRightRounded } from '@mui/icons-material'
import { useAppealCardDate } from 'feature/appeals/hooks/useAppealCardDate'
import { useOfferPriceBlock } from 'feature/appeals/components/AppealOffer/OfferPriceBlock/useOfferPriceBlock'
import { TAppealInList } from 'feature/appeals/type'
import { Status } from 'feature/statuses/types'
import { Chip, Link } from 'ui'

import style from './OrderMiniCard.module.scss'

type TOrderMiniCard = {
  appeal: TAppealInList
}
// карточка активного обращения
export function OrderMiniCard({ appeal }: TOrderMiniCard) {
  const {
    name,
    status,
    type,
    number,
    statusName,
    uid,
    orderId,
    approvedOffer,
  } = appeal
  const { icon, label } = useAppealCardDate(appeal)
  const { stageStatusName } = useOfferPriceBlock(approvedOffer, status.status)

  const displayStatusName = stageStatusName ?? statusName

  let appealStatus: Status = 'progress'

  switch (status.status) {
    case 'COMPLETED':
      appealStatus = 'done'
      break
    case 'CANCELED':
      appealStatus = 'canceled'
      break
    default:
      appealStatus = 'progress'
      break
  }

  const appealUrl = orderId
    ? `/appeals/order/${orderId}?uid=${uid}`
    : `/appeals/lead/${uid}`

  return (
    <Link
      href={
        type === 'CONSULTATION' ? `/appeals/consultation/${uid}` : appealUrl
      }
      className={style.card}
      data-testid={`appeal-card-${uid}`}
    >
      <div className={style.header}>
        <span className='h4'>{name}</span>
        <ChevronRightRounded className={style.arrow} />
      </div>
      <div className={style.data}>
        <div className={style.type}>
          <div className={style.type_icon}>{icon}</div>
          <div className={style.type_name}>{label}</div>
        </div>
        {status && (
          <div className='status'>
            <Chip status={appealStatus} label={displayStatusName} />
          </div>
        )}
        <div className={style['order-number']}>
          <span>{number}</span>
        </div>
      </div>
    </Link>
  )
}
